
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, combineLatest, of } from "rxjs";
import { map, switchMap } from 'rxjs/operators'
// import { uniq, flatten } from 'lodash'

@Injectable({
  providedIn: "root"
})

export class OrderService {

  noAuthHeader = { headers: new HttpHeaders({ "Content-Type": "application/json"}) };

  constructor(
    private http: HttpClient,
    private firestore : AngularFirestore
    ) {}

  //HttpMethods
  joined$: Observable<any>


  // get Order list
  getOrderList(): Observable<any>{
    return this.firestore.collection("orders", ref => ref.orderBy('date_created','desc')).snapshotChanges();
  }

  // Get order detail by id.
  getOrderDetailById(id): Observable<any>{
    return this.firestore.collection("orders", ref => ref.where('id', '==', id)).snapshotChanges();
  }

  
  // Edit Order
  editOrder(form,id) {
    return this.firestore.collection("orders").doc(id).update(form);
  }
}
